module.exports = __webpack_public_path__ + "img/desktop_alphaville.9d2a3578.webp";